"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useFormControlPrivate } from "./FormControl.context.js";
import FormControlCaption from "./FormControlCaption.js";
const FormControlError = (props) => {
    const { children } = props;
    const { hasError } = useFormControlPrivate();
    if (!hasError)
        return null;
    return _jsx(FormControlCaption, { variant: "error", children: children });
};
FormControlError.displayName = "FormControl.Error";
export default FormControlError;
